var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkspacesLogo2020White(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 48,
    cy: 200,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 317.1,
    cy: 311.3,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 96,
    cy: 309.8,
    r: 36.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 317.1,
    cy: 88.7,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 96,
    cy: 91.6,
    r: 36.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 363.6,
    cy: 200,
    r: 36.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.5,127.3c-40.1,0-72.7,32.6-72.7,72.7s32.6,72.7,72.7,72.7s72.7-32.6,72.7-72.7S245.7,127.3,205.5,127.3z  M205.1,237.1c-20.1,0-36.4-16.3-36.4-36.4s16.3-36.4,36.4-36.4s36.4,16.3,36.4,36.4S225.2,237.1,205.1,237.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.9,146.3c-4.9-4.4-9.7-8.9-14.5-13.4l-14.4-13.5c-4.8-4.5-9.9-8.7-14.3-13.7c-4.5-4.9-8.7-9.9-12.7-15.4 l0.3-0.3c5.5,3.8,10.5,8.1,15.4,12.7c4.9,4.5,9.2,9.5,13.7,14.3l13.5,14.4c4.5,4.9,9,9.7,13.4,14.5L151.9,146.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.1,146c4.4-4.9,8.9-9.7,13.4-14.5l13.5-14.4c4.5-4.8,8.7-9.9,13.7-14.3c4.9-4.5,9.9-8.7,15.4-12.7l0.3,0.3 c-3.8,5.5-8.1,10.5-12.7,15.4c-4.5,4.9-9.5,9.2-14.3,13.7L274,133.1c-4.9,4.5-9.7,9-14.5,13.4L259.1,146z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.1,199.9c7.1-1.2,14.3-1.6,21.2-2c7.1-0.3,14.3,0.3,21.2,0.4l21.2,0.6c7.1,0.3,14.3,0.6,21.2,0.9v0.4 c-7.1,0.3-14.3,0.6-21.2,0.9l-21.2,0.6c-7.1,0.1-14.3,0.7-21.2,0.4c-7.1-0.3-14.3-0.7-21.2-2C45.1,200,45.1,199.9,45.1,199.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.7,199.9c7.1-0.3,14.1-0.6,21.2-0.9l21.2-0.6c7.1-0.1,14.3-0.7,21.2-0.4c7.1,0.3,14.3,0.7,21.2,2v0.4 c-7.1,1.2-14.3,1.6-21.2,2c-7.1,0.3-14.3-0.3-21.2-0.4l-21.2-0.6c-7.1-0.3-14.3-0.6-21.2-0.9L280.7,199.9L280.7,199.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5,253.7c4.9,4.4,9.7,8.9,14.5,13.4l14.4,13.5c4.8,4.5,9.9,8.7,14.3,13.7c4.5,4.9,8.7,9.9,12.7,15.4 l-0.3,0.3c-5.5-3.8-10.5-8.1-15.4-12.7s-9.2-9.5-13.7-14.3l-13.5-14.4c-4.5-4.9-9-9.7-13.4-14.5L259.5,253.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.1,254c-4.4,4.9-8.9,9.7-13.4,14.5l-13.5,14.4c-4.5,4.8-8.7,9.9-13.7,14.3c-4.9,4.5-9.9,8.7-15.4,12.7 l-0.3-0.3c3.8-5.5,8.1-10.5,12.7-15.4c4.5-4.9,9.5-9.2,14.3-13.7l14.4-13.5c4.9-4.5,9.7-9,14.5-13.4L152.1,254z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspacesLogo2020White);
export default __webpack_public_path__ + "static/media/workspacesLogo2020-white.348b7be19bf449b6ee6023cef4127c8c.svg";
export { ForwardRef as ReactComponent };